// @flow
import env from '../../environment';
import {getCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_RELATED_RESOURCES: `${env.baseApiUrl}/im/admin/store-reference-entity`,
});

export const getRelatedResourcesApi = getCreator(
  endpoints.GET_RELATED_RESOURCES
);
